/* eslint-disable react-hooks/exhaustive-deps */
import { Menu } from 'antd'
import React, { useEffect, useState } from 'react'
import HeaderComponent from 'components/HeaderComponentNew'
import Scrollbar from 'react-custom-scrollbars'
import MasterCriteria from 'pages/ClinicProfile/Mastery'
import CustomProfileLayout from './Clinic/CustomLayout'
import UserRunMasterySetting from '../ClinicProfile/userRunMasterySetting'
import PreferredItem from './PreferredItem'
import SessionSettingTab from './SessionSettingTab'
import PeakAutomaticTab from '../../components/AssessmentsProfileTab/PeakAutomaticTab'

const tabs = [
  {
    key: 'Run-Mastery',
    title: 'Run Mastery',
    component: <UserRunMasterySetting />,
    // iconName: <ProfileOutlined />,
  },
  {
    key: 'Mastery-Criteria',
    title: 'Mastery Criteria',
    component: <MasterCriteria />,
    // iconName: <ProfileOutlined />,
  },
  {
    key: 'Target-types',
    title: 'Target Types',
    component: <PeakAutomaticTab />,
    // iconName: <ProfileOutlined />,
  },
  {
    key: 'Learner-Session-Setting',
    title: 'Learner Session Setting',
    component: <SessionSettingTab />,
    // iconName: <ProfileOutlined />,
  },
  {
    key: 'Preferred-Items',
    title: 'Preferred Items',
    component: <PreferredItem />,
    // iconName: <ProfileOutlined />,
  },
]

const SessionSettingLayout = () => {
  const [rightComponent, setRightComponent] = useState(<UserRunMasterySetting />)
  const [panelHeading, setPanelHeading] = useState('Run Mastery')

  const handleMenuChange = item => {
    const selectedItem = tabs.find(tab => tab.key === item.key)
    setPanelHeading(selectedItem.title)
    if (selectedItem) setRightComponent(selectedItem.component)
  }

  return (
    <CustomProfileLayout
      leftContent={
        <>
          <Menu
            style={{ height: 'calc(100vh - 175px)' }}
            onSelect={handleMenuChange}
            mode="inline"
            defaultSelectedKeys={['Run-Mastery']}
          >
            {tabs.map(tab => {
              if (!tab.submenu) {
                return (
                  <Menu.Item key={tab.key}>
                    {/* {tab.iconName} */}
                    <span>{tab.title}</span>
                  </Menu.Item>
                )
              }
              return (
                <Menu.SubMenu
                  title={
                    <span>
                      {tab.iconName}
                      <span>{tab.title}</span>
                    </span>
                  }
                  key={tab.key}
                  onTitleClick={() => handleMenuChange({ key: tab.key })}
                >
                  {tab.submenu.map(label => (
                    <Menu.Item key={label[0]}>
                      {label[1]} <span>{label[0]}</span>
                    </Menu.Item>
                  ))}
                </Menu.SubMenu>
              )
            })}
          </Menu>
        </>
      }
      rightContent={
        <>
          <HeaderComponent
            title={panelHeading}
            showHomePath={false}
            learnerCard={
              panelHeading !== 'Run Mastery' &&
              panelHeading !== 'Mastery Criteria' &&
              panelHeading !== 'Target Types'
            }
            pathList={['Session Settings']}
          />
          <div style={{ minHeight: 360, margin: '0 10px' }}>
            <Scrollbar style={{ height: 'calc(100vh - 150px)' }}>
              <div>{rightComponent}</div>
            </Scrollbar>
          </div>
        </>
      }
    />
  )
}

export default SessionSettingLayout
